import { render, staticRenderFns } from "./four.vue?vue&type=template&id=3b75a47d&scoped=true"
import script from "./four.vue?vue&type=script&lang=js"
export * from "./four.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/quesstion.css?vue&type=style&index=0&id=3b75a47d&prod&scoped=true&lang=css&external"
import style1 from "./four.vue?vue&type=style&index=1&id=3b75a47d&prod&scoped=true&lang=css"
import style2 from "./four.vue?vue&type=style&index=2&id=3b75a47d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b75a47d",
  null
  
)

export default component.exports